import { ComponentRef, ReactNode, RefObject } from "react";
import { cn } from "src/utils/cn";
function getClipDurationHuman(rawSeconds: number) {
  const roundSeconds = Math.round(rawSeconds);
  const minutes = Math.floor(roundSeconds / 60);
  const seconds = String(roundSeconds % 60).padStart(2, "0");
  return minutes + ":" + seconds;
}

type ClipCardWrapperProps = {
  durationSeconds: number;
  sequenceNumber?: number;
  footerRef?: RefObject<ComponentRef<"div"> | null>; // required to calculate position of the pop-out menu
  menuElement?: ReactNode;
  children: ReactNode;
  "data-test"?: string;
  clipContainerClassName?: string;
  isDragging: boolean;
  isLocked?: boolean;
};

export const ClipCardWrapper = ({
  durationSeconds,
  sequenceNumber,
  footerRef,
  menuElement,
  "data-test": dataTest,
  clipContainerClassName,
  children,
  isDragging,
  isLocked = false,
}: ClipCardWrapperProps) => {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-md bg-gray-50",
        isDragging ? "cursor-grabbing" : "cursor-grab",
        isLocked && "grayscale"
      )}
      data-test={dataTest}
    >
      <div className={cn("aspect-video w-full", clipContainerClassName)}>
        {children}
      </div>
      <div
        className="flex h-10 w-full items-center justify-between p-1 text-gray-700"
        ref={footerRef}
      >
        <span className="flex items-center space-x-2 text-xs">
          {sequenceNumber ? (
            <span className="flex h-5 w-5 items-center justify-center rounded-md bg-gray-200">
              {sequenceNumber}
            </span>
          ) : null}
          <span className="text-gray-400">
            {getClipDurationHuman(durationSeconds)}
          </span>
        </span>
        {menuElement}
      </div>
    </div>
  );
};
